import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddEditSubjectMasterDialog from './AddEditSubjectMaster';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { InputSwitch } from 'primereact/inputswitch';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const SubjectMaster = () => {
    const { catchResponse } = useCatchResponse();
    const [subjectList, setSubjectList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [subjectId, setSubjectId] = useState('');
    const [visible, setVisible] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        SubjectName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        board: { value: null, matchMode: FilterMatchMode.CONTAINS },
        medium: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sections: { value: null, matchMode: FilterMatchMode.EQUALS },
        students: { value: null, matchMode: FilterMatchMode.EQUALS },
        totalCapacity: { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isStatusConfirmation, setIsStatusConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [visibleStudentList, setVisibleStudentList] = useState(false);
    const [masterStudentList, setMasterStudentList] = useState([]);
    const [visibleClassList, setVisibleClassList] = useState(false);
    const [masterClassList, setMasterClassList] = useState([]);
    const [updatedStatus, setUpdatedStatus] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
                await GetSubjectList(loginData?._id);
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['SubjectName'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetSubjectList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getSubjectList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setSubjectList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err);
            catchResponse(err);
        }
    }

    const UpdateSubjectStatus = async () => {
        try {
            let data = {
                id: deleteId,
                Status: updatedStatus
            }
            await api.post(APIConstant.path.updateSubjectDetailStatus, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    setDeleteId('');
                    setUpdatedStatus('');
                    Toast.success({ message: 'Subject status updated successfully' });
                    GetSubjectList(securityUserID);
                    setIsStatusConfirmation(false);
                }
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                setIsStatusConfirmation(false);
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            setDeleteId('');
            setUpdatedStatus('');
            setIsStatusConfirmation(false);
            catchResponse(err);
        }
    }

    const DeleteSubjectStatus = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.deleteSubjectDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    setDeleteId('');
                    Toast.success({ message: 'Subject deleted successfully' });
                    GetSubjectList(securityUserID);
                    setIsDeleteConfirmation(false);
                }
            }).catch(err => {
                Loader.hide();
                setIsDeleteConfirmation(false);
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            setIsDeleteConfirmation(false);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center p-jc-end'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-m-1" onClick={() => {
                        setSubjectId(rows._id)
                        setMasterData(rows);
                        setIsEdit(true)
                        setVisible(true)
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-m-0" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                    <InputSwitch
                        checked={rows?.Status === 'Active' ? true : false}
                        onChange={(e) => {
                            toggleActiveStatus(rows._id,e.value);
                        }}
                        className="p-ml-2 p-mt-1"
                    />
                </div>
            </React.Fragment>
        );
    };

    const toggleActiveStatus = (id,status) => {
        setDeleteId(id);
        setUpdatedStatus(status === true ? 'Active' : 'Inactive');
        setIsStatusConfirmation(true);
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteSubjectStatus()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const renderStatusFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseStatus}
            />
            <Button
                label="Update"
                className="btn-text-action-primary"
                onClick={(e) => UpdateSubjectStatus()}
            />
        </div>
    );

    const handleCloseStatus = () => {
        setIsStatusConfirmation(false)
    };

    const onCancel = () => {
        setVisible(false);
        setSubjectId('');
        setIsEdit(false);
        setMasterData([]);
        GetSubjectList(securityUserID);
    }

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const classCountBodyTemplateSrNo = (data, props) => {
        return <div onClick={() => {
            setVisibleClassList(true);
            setMasterClassList(data?.ClasssList)
        }}>{data?.ClassesCount}</div>
    };

    const teacherCountBodyTemplateSrNo = (data, props) => {
        return <div onClick={() => {
            setVisibleStudentList(true);
            setMasterStudentList(data?.TeachersList)
        }}>{data?.TeachersName}</div>
    };

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-book"></i>
                    <h2>Subject Master</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                </div>
            </div>
            <DataTable
                value={subjectList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                globalFilterFields={['SubjectName', 'SubjectId']}
                responsiveLayout="scroll"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
            >
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{ minWidth: '6rem', maxWidth: '6rem' }}/>
                <Column
                    field="SubjectName"
                    header="Subject No"
                />
                <Column
                    field="SubjectId"
                    header="Subject Code"
                />
                <Column
                    body={classCountBodyTemplateSrNo}
                    header="Applicable Classes"
                />
                <Column
                    body={teacherCountBodyTemplateSrNo}
                    header="Assigned Teachers"
                />
                <Column
                    field='IsGradeValue'
                    header="Grade"
                />
                <Column
                    field='IsOptionalValue'
                    header="IsOptional"
                />
                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '100%'}}/>
            </DataTable>
            <Dialog
                header={subjectId ? "Edit Subject Master" : "Add Subject Master"}
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: "60vw"}}
            >
                <AddEditSubjectMasterDialog masterData={masterData} isEdit={isEdit} ID={subjectId} onCancel={onCancel} />

            </Dialog>
            <Dialog
                header="Teachers List"
                // className='dialog-popup'
                visible={visibleStudentList}
                onHide={() => {
                    setVisibleStudentList(false)
                    setMasterStudentList([]);
                }}
                draggable={false}
                position="center">

                <div className="p-col-12 p-card p-p-3">
                    <DataTable value={masterStudentList} paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rowsPerPageOptions={[10, 20, 50]} className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'>
                        <Column body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column field="Name" header="Teacher Name" />
                        <Column field="Email" header="Email" />
                        <Column field="Phone" header="Phone" />
                    </DataTable>
                </div>
            </Dialog>
            <Dialog
                header="Class List"
                visible={visibleClassList}
                onHide={() => {
                    setVisibleClassList(false)
                    setMasterClassList([]);
                }}
                draggable={false}
                position="center">

                <div className="p-col-12 p-card p-p-3">
                    <DataTable value={masterClassList} paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rowsPerPageOptions={[10, 20, 50]} className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'>
                        <Column body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column field="ClassName" header="Class Name" />
                        <Column field="Section" header="Section Name" />
                        <Column field="Board" header="Board Name" />
                        <Column field="Medium" header="Medium" />
                    </DataTable>
                </div>
            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
            <Dialog
                visible={isStatusConfirmation}
                onHide={handleCloseStatus}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Status Update</span>
                    </div>
                }
                footer={renderStatusFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div>
                    <p>
                        Are you sure you want to update status?
                    </p>
                </div>
            </Dialog>
        </div>
    );
};

export default SubjectMaster;
